import Button from '../../../components/base/Button';

export default function PricingSection() {
  const plans = [
    {
      name: 'LP制作',
      price: '30,000',
      period: '円',
      description: '地元の人限定価格',
      features: [
        'レスポンシブデザイン',
        'お問い合わせフォーム',
        '1ページ制作'
      ],
      popular: false,
      note: '地元の人限定'
    },
    {
      name: 'ホームページ制作',
      price: '250,000',
      period: '円',
      description: 'ビジネスサイト',
      features: [
        'カスタムデザイン',
        '複数ページ対応',
        '5ページまで',
        '2ヶ月サポート',
        'Google Analytics設定',
        'SNS連携',
        'ブログ機能'
      ],
      popular: false
    },
    {
      name: 'セットプラン',
      price: '250,000',
      period: '円',
      description: 'LP制作 + ホームページ制作',
      features: [
        'LP制作（1ページ）',
        'ホームページ制作（5ページ）',
        'カスタムデザイン',
        '基本的SEO対策',
        '3ヶ月サポート',
        'Google Analytics設定',
        'SNS連携'
      ],
      popular: true
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            <strong>地元価格</strong>でご提供
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            沖縄の起業家を応援する特別価格。LP制作からホームページまで幅広く対応いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div key={index} className={`relative rounded-2xl p-8 ${plan.popular ? 'bg-gradient-to-b from-blue-50 to-teal-50 border-2 border-blue-200 shadow-xl' : 'bg-white border border-gray-200 shadow-lg'}`}>
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-gradient-to-r from-blue-600 to-teal-500 text-white px-6 py-2 rounded-full text-sm font-medium">
                    おすすめ
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h4 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h4>
                <p className="text-gray-600 mb-4">{plan.description}</p>
                {plan.note && (
                  <p className="text-sm text-orange-600 font-medium mb-2">※ {plan.note}</p>
                )}
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-xl text-gray-600 ml-1">{plan.period}</span>
                </div>
              </div>
              
              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
              
              <button 
                className={`w-full py-3 px-6 rounded-lg font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  plan.popular 
                    ? 'bg-gradient-to-r from-blue-600 to-teal-500 text-white hover:from-blue-700 hover:to-teal-600 shadow-lg hover:shadow-xl' 
                    : 'border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white'
                }`}
                onClick={() => {
                  const contactSection = document.getElementById('contact');
                  if (contactSection) {
                    contactSection.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                プランを選択
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            ※ 価格は税込表示です。詳細なお見積りは無料相談にてご提案いたします
          </p>
          <Button variant="secondary" href="#contact">
            <i className="ri-calculator-line mr-2"></i>
            無料見積もりを依頼
          </Button>
        </div>
      </div>
    </section>
  );
}
